import React, { useState } from 'react'

interface ExpandableCellProps {
	text: string
	maxLines?: number
	width?: string // Optional width prop (e.g., "200px")
}

const ExpandableCell: React.FC<ExpandableCellProps> = ({
	text,
	maxLines = 3,
	width = '250px'
}) => {
	const [expanded, setExpanded] = useState(false)

	const isLong = text.length > 100

	return (
		<div style={{ width, wordBreak: 'break-word' }}>
			<div
				style={{
					display: '-webkit-box',
					marginTop: '4px',
					WebkitLineClamp: expanded ? 'none' : maxLines,
					WebkitBoxOrient: 'vertical',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: expanded ? 'normal' : 'initial',
					maxHeight: expanded ? 'none' : `${1.5 * maxLines}em`,
					cursor: 'default'
				}}
			>
				{text}
			</div>
			{isLong && (
				<div
					onClick={() => setExpanded(!expanded)}
					style={{
						color: '#3f51b5',
						cursor: 'pointer',
						// marginTop: '4px',
						fontSize: '12px'
					}}
				>
					{expanded ? 'Show Less' : '...'}
				</div>
			)}
		</div>
	)
}

export default ExpandableCell
